import { Box, Flex, HStack, Text, Spacer, Icon } from '@chakra-ui/react';
import ContentContainer from '~/containers/Content';

import { IoLocationSharp } from 'react-icons/io5';
import React, { useMemo } from 'react';

import remotePickMealPointAtom from '~/recoil/atom/remotePickMealPoint';
import { useRecoilValue } from 'recoil';
import globalEnterpriseGroupBuyAtom from '~/recoil/atom/enterpriseGroupBuy/globalEnterpriseGroupBuyAtom';
import { useParams } from 'react-router-dom';

type LocationBarProps = {
  rightHandComponent?: React.ReactNode;
  onClick?: () => void;
};

export default function LocationBar({ rightHandComponent, onClick }: LocationBarProps) {
  const enterpriseGroupBuyData = useRecoilValue(globalEnterpriseGroupBuyAtom);
  const remotePickMealPoint = useRecoilValue(remotePickMealPointAtom);
  const { enterpriseGroupBuyId = '' } = useParams();

  const displayLocationName = useMemo(() => {
    if (!!enterpriseGroupBuyId) {
      return enterpriseGroupBuyData?.data?.addressSpec;
    } else {
      return remotePickMealPoint?.name;
    }
  }, [remotePickMealPoint?.name, enterpriseGroupBuyData?.data?.addressSpec, enterpriseGroupBuyId]);

  return (
    <Box bgColor="primary" px={4} onClick={onClick} cursor={onClick ? 'pointer' : 'unset'}>
      <ContentContainer>
        <Flex align="center" py={2} minH="2.75rem">
          <HStack spacing={2}>
            <Icon as={IoLocationSharp} boxSize="1.5rem" color="white" />
            <Text color="white" fontWeight="bold" fontSize="lg">
              {displayLocationName || ''}
            </Text>
          </HStack>
          <Spacer />
          {rightHandComponent}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
